import http from "./http-common";

class EmergencyService {
  queryString(payload = {}) {
    return Object.entries(payload || {})
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
  }

  getEmergencyVisitList(payload = { pageNo: 1, pageSize: 50 }) {
    const query = this.queryString(payload);
    return http.get(
      query ? `/EmergencyVisit/list/filter?${query}` : `/EmergencyVisit/list/filter`
    );
  }

  getEmergencyVisitById(id) {
    return http.get(`/EmergencyVisit/${id}`);
  }
}

export default new EmergencyService();
